<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
        { label: 'RECETAS', link: '/dashboard' },
        { label: 'DETALLE DE RECETA' }]">
      </app-breadcrumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-4 col-md-12">
        <div class="card">
          <div class="m-b-20">
            <div class="contact-grid">
              <div class="profile-header bg-rmd-blue">
                <div class="user-name">RECETA ({{ estatusReceta }})</div>
                <div class="name-center">{{ folio }}</div>
              </div>
              <img alt="" class="user-img" src="{{userImage}}">
              <div class="name-center">FECHA DE CREACION: {{ param2 }}</div>
              <div class="name-center" *ngIf="canDownloadPdf"><h5>DESCARGAR RECETA</h5></div>
              <div class="name-center" *ngIf="canDownloadPdf"><span class="mobile-label">DESCARGAR RECETA:</span>
                <button
                  (click)="$event.stopPropagation(); descargarPDF()"
                  class="tbl-fav-std"
                  mat-icon-button data-tour="pat-rx-detail-download">
                  <app-feather-icons [icon]="'download'"></app-feather-icons>
                </button>
                <button
                  (click)="$event.stopPropagation(); enviarRecetaPorCorreo()"
                  class="tbl-fav-std"
                  mat-icon-button
                  matTooltip="Enviar receta por correo">
                  <mat-icon>mail</mat-icon>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-md-12">
        <div class="card">
          <mat-tab-group>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon msr-2">list_alt</mat-icon>
                <span data-tour="pat-rx-detail-tab-meds">MEDICAMENTOS</span>
              </ng-template>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="project_widget" data-tour="pat-rx-detail-meds-list">
                  @for (detalle of detalles; track detalle) {
                    <div class="header">
                      <h2><strong>{{ detalle.medicamentoNombre }}</strong></h2>
                    </div>
                    <div class="body">
                      <div class="row">
                        <div class="col-md-4 col-6 b-r">
                          <strong>DOSIS</strong>
                          <br>
                          <p
                            class="text-muted">{{ detalle.cantidadDiaria }} {{ detalle.unidadDispensacion }}</p>
                        </div>
                        <div class="col-md-4 col-6 b-r">
                          <strong>FRECUENCIA</strong>
                          <br>
                          <p class="text-muted">{{ detalle.frecuency }} {{ detalle.frecuencyType }}
                            POR {{ detalle.duracion }} {{ detalle.unidadDuracion }}</p>
                        </div>
                        <div class="col-md-4 col-6 b-r">
                          <strong>RUTA DE ADMINISTRACION</strong>
                          <br>
                          <p class="text-muted">{{ detalle.rutaAdministracion | capitalize }}</p>
                        </div>
                        <div class="col-md-4 col-6 b-r">
                          <strong>TIPO</strong>
                          <br>
                          <p class="text-muted">{{ detalle.medicamentoType }} </p>
                        </div>
                        <div class="col-md-4 col-6 b-r">
                          <strong>PERIODO DE INICIO</strong>
                          <br>
                          <p class="text-muted">{{ detalle.periodoInicio }} </p>
                        </div>
                        <div class="col-md-4 col-6 b-r">
                          <strong>PERIODO DE TERMINACION</strong>
                          <br>
                          <p class="text-muted">{{ detalle.periodoTerminacion }}</p>
                        </div>
                        <div class="col-md-4 col-6 b-r">
                          <strong>MOTIVO DE USO</strong>
                          <br>
                          <p class="text-muted">{{ detalle.indicacionNombre }}</p>
                        </div>
                        <div class="col-md-4 col-6 b-r">
                          <strong>INDICACIONES DE USO</strong>
                          <br>
                          <p class="text-muted">{{ detalle.observaciones }}</p>
                        </div>
                        <div class="col-md-4 col-6 b-r">
                          <strong>SURTIDO</strong>
                          <br>
                          <p [ngClass]="detalle.surtido ? 'text-success' : 'text-danger'">
                            {{ detalle.surtido ? 'SI' : 'NO' }}
                          </p>
                        </div>
                      </div>

                        <div class="row">
                          <div class="col-md-9 col-12 b-r" *ngIf="detalle.descripcion">
                            <h5><strong>RECCIONES CAUSADAS POR EL MEDICAMENTO:</strong></h5>
                          </div>
                          <div class="col-md-3 col-6 b-r">
                            @if (!detalle.descripcion) {
                              <button color="primary" mat-raised-button (click)="updateLine(detalle)"
                                      *ngIf="detalle.generarEventoMedicamentoso" data-tour="pat-rx-add-med-event">
                                {{ 'AÑADIR EVENTO DE MEDICACION' }}
                              </button>
                            }
                          </div>
                          @if (detalle.descripcion) {
                            <div class="col-md-12 col-12 b-r">
                              <p class="text-muted">{{ detalle.descripcion }}</p>
                            </div>
                          }
                        </div>
                    </div>
                    <mat-divider/>
                  }
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</section>
